import { Suspense, lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import LoadingSpinner from '@/components/LoadingSpinner'

// Lazy load components
const Enamel = lazy(
  async () => import('@/pages/getRecipe/microLayering/enamel'),
)
const InternalEffects = lazy(
  async () => import('@/pages/getRecipe/microLayering/internalEffects'),
)
const MaterialAdvice = lazy(
  async () => import('@/pages/getRecipe/microLayering/materialAdvice'),
)
const Staining = lazy(
  async () => import('@/pages/getRecipe/microLayering/staining'),
)

const MicroLayeringRoutes = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="material-advice" element={<MaterialAdvice />} />
        <Route path="staining" element={<Staining />} />
        <Route path="internal-effects" element={<InternalEffects />} />
        <Route path="enamel" element={<Enamel />} />
        <Route
          path=""
          element={<Navigate to="material-advice" replace={true} />}
        />
      </Routes>
    </Suspense>
  )
}

export default MicroLayeringRoutes
